import { TextEffect } from 'types/Effects';
import Konva from 'konva';
import { RGBAObjToFill } from 'utils/konva/color';
import { OUTLINE_STROKE_WIDTH } from 'constants/textTool';

export default ({
  id,
  width: effectWidth,
  text,
  position: { x, y },
  font: { fontFamily },
  fontSize,
  textColor,
  textOpacity,
  shadowColor,
  shadowOpacity,
  shadowBlur,
  shadowOffsetX,
  shadowOffsetY,
  outlineColor,
  outlineOpacity,
  outlineSize,
  textAlign,
  isBold,
  isItalic,
  isUnderline,
  line,
  letter,
  transformedText
}: TextEffect): Konva.TextConfig => ({
  id,
  x,
  y,
  width: effectWidth,
  fill: textColor && RGBAObjToFill({ ...textColor, a: textOpacity }),
  shadowColor: shadowColor && RGBAObjToFill({ ...shadowColor, a: shadowOpacity }),
  shadowOffset: { x: shadowOffsetX, y: shadowOffsetY },
  shadowBlur: shadowBlur && shadowBlur * 70,
  stroke: outlineColor && RGBAObjToFill({ ...outlineColor, a: outlineOpacity }),
  strokeWidth: outlineSize && outlineSize * OUTLINE_STROKE_WIDTH,
  text: transformedText || text,
  fontFamily,
  fontSize,
  fontStyle: `${isItalic ? 'italic ' : ''}${isBold ? 'bold ' : ''}`,
  textDecoration: `${isUnderline ? 'underline' : ''}`,
  align: textAlign,
  verticalAlign: 'top',
  lineHeight: line || 1,
  letterSpacing: letter || 0,
  draggable: true,
  fillAfterStrokeEnabled: true,
  lineCap: 'round',
  lineJoin: 'round'
});
